import { useEffect, useState } from 'react';
import './SectionComponent.css';
import Grow from '@mui/material/Grow';

function AboutMeSection({currentHash}) {
    const [showImage, setShowImage] = useState(currentHash === 'sobremi')
    const [clear, setClear] = useState(false)
    const [showText, setShowText] = useState(currentHash === 'sobremi')

    useEffect(()=>{
        if(clear){
            setShowImage(false)
            setShowText(false)
        }
    }, [clear])

    useEffect(()=>{
        if(window.innerWidth <= 900 ){
            setShowImage(true)
            setShowText(true)
        }else{
            if(currentHash === 'sobremi'){
                setTimeout(() => {
                    setShowImage(true)
                }, 200);
                setTimeout(() => {
                    setShowText(true)
                }, 250);
                setClear(false)
            }else if(currentHash === 'home') setClear(true)
            else {
                setShowText(true)
                setShowText(true)
            }
        }
    }, [currentHash]);

    return (
        <div id="sobremi" className="App-section App-section-sobre_mi text-right anchor_tags">
            <Grow in={showImage}>
                <div className="img-frame">
                    <img src={require("../../assets/img/AboutMe.jpg")} alt="AboutMe" width="300px"/>
                </div>
            </Grow>
            <Grow in={showText}>
                <div>
                    <h2>Sobre mi</h2>
                    <p><strong>Licenciada en Relaciones Laborales.</strong> Diplomada en el Programa de Formación Gerencial en Gestión de las Personas y en el Programa de Formación Gerencial en Innovación de IDEA. Certificada internacionalmente como <strong>Coach Ontológico Profesional.</strong> Con <strong>más de 15 años de experiencia</strong> como Profesional de Recursos Humanos, con orientación en liderazgo y gestión de equipos.</p>
                    <a
                        href="#contacto"
                    >
                        Contacto
                    </a>
                </div>
            </Grow>
        </div>
    );
}

export default AboutMeSection;